
<div class="file-loader-table">
  <data-table
    :headers="headers"
    :items="files"
    :loading="loading"
    :items-per-page="itemsPerPage"
    :hide-default-footer="files.length <= itemsPerPage"
    class="elevation-0"
    :aria-label="'File load log table'"
    :data-testid="'file-loader-table'"
  >
    <!-- Loading slot -->
    <template #progress>
      <v-progress-linear
        indeterminate
        color="primary"
        aria-live="polite"
        aria-label="Loading file data"
      />
    </template>

    <!-- Loaded Date column -->
    <template #item.loadedDate="{ item }">
      <span class="text-body-2">
        {{ formatDate(item.loadedDate) }}
      </span>
    </template>

    <!-- File Name column -->
    <template #item.fileName="{ item }">
      <div class="d-flex align-center">
        <v-icon
          v-if="item.loadStatus === 'failed'"
          small
          color="error"
          class="mr-2"
          :aria-label="'Failed file'"
        >
          mdi-close-circle
        </v-icon>
        <span
          class="text-body-2"
          :class="{ 'error--text': item.loadStatus === 'failed' }"
        >
          {{ item.fileName }}
        </span>
      </div>
    </template>

    <!-- File Type column -->
    <template #item.fileType="{ item }">
      <file-loader-type-badge :file-type="item.fileType" />
    </template>

    <!-- Load Status column -->
    <template #item.loadStatus="{ item }">
      <status-badge
        :status="item.loadStatus === 'success' ? 'Success' : 'Failed'"
        :type="item.loadStatus === 'success' ? 'success' : 'error'"
      />
    </template>

    <!-- Rows Accepted column -->
    <template #item.rowsAccepted="{ item }">
      <span
        class="text-body-2 font-weight-medium"
        :class="item.rowsAccepted > 0 ? 'success--text' : 'grey--text'"
      >
        {{ item.rowsAccepted.toLocaleString() }}
      </span>
    </template>

    <!-- Rows Rejected column -->
    <template #item.rowsRejected="{ item }">
      <span
        class="text-body-2 font-weight-medium"
        :class="item.rowsRejected > 0 ? 'error--text' : 'grey--text'"
      >
        {{ item.rowsRejected.toLocaleString() }}
      </span>
    </template>

    <!-- Submissions Created column -->
    <template #item.submissionsCreated="{ item }">
      <span
        class="text-body-2 font-weight-medium"
        :class="item.submissionsCreated > 0 ? 'primary--text' : 'grey--text'"
        :style="item.submissionsCreated > 0 ? 'cursor: pointer; text-decoration: underline;' : ''"
        @click="item.submissionsCreated > 0 ? handleSubmissionsClick(item) : null"
      >
        {{ item.submissionsCreated.toLocaleString() }}
      </span>
    </template>

    <!-- Duration column -->
    <template #item.durationSeconds="{ item }">
      <span class="text-body-2 grey--text text--darken-1">
        {{ formatDuration(item.durationSeconds) }}
      </span>
    </template>

    <!-- Empty state -->
    <template #no-data>
      <div class="text-center py-8">
        <v-icon size="48" color="grey lighten-1">mdi-file-document-outline</v-icon>
        <div class="text-h6 grey--text mt-4">No files found</div>
        <div class="text-body-2 grey--text">Files will appear here once they are processed</div>
      </div>
    </template>
  </data-table>
</div>
